import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, SalesEnquiry } from "@/v2/types";

export default async function FetchSalesEnquiryAnaltyics({
    limit,
    skip,
    search,
    filter,
}: {
    skip: number;
    limit: number;
    search?: string;
    filter?: Record<string, string>;
}): Promise<{ data: SalesEnquiry[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/sales-enquiries/analtyics",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
            ...filter,
        },
    });
    return res.data;
}
